<div class="translations-banner-wrapper">
  @if (userLang && LINK_TARGET) {
    <div class="banner-shell" [class.mobile-disclaimer-expanded]="mobileDisclaimerExpanded">
      <button
        class="banner-wrapper"
        (click)="openTargetInNewPage()"
        (keydown.enter)="openTargetInNewPage()"
        (keydown.space)="openTargetInNewPage(); $event.preventDefault()"
        [attr.aria-labelledby]="'translations-banner-slogan'"
        [class.fix-ru]="userLang === 'ru'"
        [class.fix-uk]="userLang === 'uk'"
        [class.fix-en]="userLang === 'en'"
        [class.fix-pl]="userLang === 'pl'">
        <span id="translations-banner-slogan" class="sr-only" [innerHTML]="'TRANSLATIONS_BANNER.SLOGAN' | translate">
        </span>
        <div class="column align-end" aria-hidden="true">
          <video muted autoplay loop playsinline tabindex="-1">
            <source src="https://kartapobytu.app/kp/anim-simple-translations-fixed-bg.mp4" type="video/mp4" />
          </video>
        </div>
        <div class="column align-start" inert>
          <div class="slogan-container" [innerHTML]="'TRANSLATIONS_BANNER.SLOGAN' | translate"></div>
          @if (deviceTypeDetected === 'DESKTOP' || deviceTypeDetected === 'TABLET') {
            <div class="disclaimer-container" [innerHTML]="'TRANSLATIONS_BANNER.DISCLAIMER' | translate"></div>
          }
        </div>
      </button>
      @if (deviceTypeDetected === 'PHONE') {
        <div
          id="translations-mobile-disclaimer"
          class="mobile-disclaimer-panel"
          [class.expanded]="mobileDisclaimerExpanded"
          [attr.aria-hidden]="!mobileDisclaimerExpanded">
          <div class="mobile-disclaimer-content">
            <div class="disclaimer-container" [innerHTML]="'TRANSLATIONS_BANNER.DISCLAIMER' | translate"></div>
          </div>
        </div>
        <button
          type="button"
          class="mobile-disclaimer-handle"
          (click)="toggleMobileDisclaimer()"
          [attr.aria-expanded]="mobileDisclaimerExpanded"
          aria-controls="translations-mobile-disclaimer">
          <span class="sr-only" [innerHTML]="'TRANSLATIONS_BANNER.DISCLAIMER' | translate"></span>
          @if (!mobileDisclaimerWasRevealed) {
            <mat-icon class="attention-icon" fontSet="material-icons-outlined" aria-hidden="true">
              priority_high
            </mat-icon>
          }
          <mat-icon class="chevron-icon" [class.expanded]="mobileDisclaimerExpanded" aria-hidden="true">
            expand_more
          </mat-icon>
        </button>
      }
    </div>
  }
</div>
